import PrivateRoute, { Router } from 'components/app-layout/PrivateRoute';

import IpBlacklistsGridLayout from './containers/Grid'

export default function IpBlacklistLayout() {
  return <Router>
    <PrivateRoute path="/settings/ip-blacklist" component={IpBlacklistsGridLayout} />
  </Router>;
}
